import React from "react";

import Applet from "../../Applet";
import ProjectPlanPhaseMilestoneReferenceTable from "../../../../components/ProjectPlan/ProjectPlanPhaseMilestoneReferenceTable";
import ProjectPlanPhaseMilestoneEmployeeTable from "../../../../components/ProjectPlan/ProjectPlanPhaseMilestoneEmployeeTable";

class ProjectPlanPhaseMilestoneEmployeeTableApplet extends Applet {

    render() {
        return <ProjectPlanPhaseMilestoneEmployeeTable applet={this}
                                 pageSize={this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Assignees"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectPlanPhaseMilestoneEmployeeTableApplet",
        Menu: {
            options: [
                {
                    privileges: [
                        "Add Assignee"
                    ],
                    displayValue: "New Assignee",
                    value: "New Assignee",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "EmployeeName",
                },
                {
                    id: "Actions",
                },

            ]
        },
        Columns: [
            {
                id: "EmployeeName",
                width: 140,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": "EmployeeName",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "EmployeeName",
                    "DisplayName": "Name",
                }],
            },
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "EmployeeName",
                                }
                           ]
                        }
                    ]
                }
            },
            Controls: {
                "EmployeeName": {
                    id: "EmployeeName",
                    enterpriseComponentAttribute: "EmployeeName",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Assignee",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                }
            }
        }
    }
}

export default ProjectPlanPhaseMilestoneEmployeeTableApplet;
